import { Component } from "@angular/core";
import { NavController } from "ionic-angular";
import { Storage } from "@ionic/storage";
import { AlertController } from "ionic-angular/components/alert/alert-controller";
import { Events } from "ionic-angular/util/events";
import { WhiskyDB } from "../../data/db";
import { User } from "../../providers/providers";
import { LoginPage } from "../login/login";
import { LoadingController } from "ionic-angular/components/loading/loading-controller";
import { ToastController } from "ionic-angular/components/toast/toast-controller";
import { ModalController } from "ionic-angular/components/modal/modal-controller";
import { AppRate } from "@ionic-native/app-rate";
import { WhiskySync } from "../../data/sync";
import { ImageSync } from "../../data/imageSync";
//import { WhiskyDB_fb } from "../../data/fbDb";

@Component({
  selector: "page-contact",
  templateUrl: "contact.html"
})
export class ContactPage {
  whiskies: any = 0;
  distilleries: any = 0;
  sequence: string = "-1";
  sync: WhiskySync;
  imgSync: ImageSync;

  resetCounts() {
    this.whiskies = WhiskyDB.whisky.length;
    this.distilleries = WhiskyDB.distilleries.length;
  }
  version: "unknown";
  build: "unknown";

  /*migrateToFb()
  {
    WhiskyDB_fb.migratefromLocal();
  } */

  isNetworkUp()
  {
    return WhiskyDB.networkUp;
  }

  constructor(
    public navCtrl: NavController,
    public storage: Storage,
    public alertCtrl: AlertController,
    public events: Events,
    public user: User,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private appRate: AppRate //private zeroconf: Zeroconf
  ) {
    this.resetCounts();
    this.loginPage = LoginPage;
    this.sync = new WhiskySync();
    this.imgSync = new ImageSync(this.events, this);

    console.log("Version: " + this.version + " build: " + this.build);

    events.subscribe("login:done"),
      val => {
        console.log("event login:done");
        this.checkAuth();
        this.ionViewWillEnter();
      };
      
    events.subscribe("whiskies:updated", val => {
      this.ionViewWillEnter();        
    });
      
    events.subscribe("update:loading", name => {
      this.loading_image = name;
    });
    events.subscribe("update:saving", name => {
      this.saving_image = name;
    });
    events.subscribe("update:done", () => {
      let toast = this.toastCtrl.create({
        message: "Done loading images",
        duration: 3000
      });
      toast.present();

      this.ionViewWillEnter();

      this.saving = null;
    });
  }

  loginPage: any;
  isAuth: boolean = false;
  isAuthenticated = false;

  checkAuth() {
    this.user
      .isAuthenticated()
      .then(() => {
        this.isAuth = true;
        this.isAuthenticated = true;
      })
      .catch(() => {
        this.isAuth = false;
        this.isAuthenticated = false;
      });
  }

  rateMe() {
    console.log("RateMe pressed!");

    this.appRate.preferences = {
      displayAppName: "WhiskyWall",
      usesUntilPrompt: 5,
      promptAgainForEachNewVersion: false,
      //inAppReview: true,
      storeAppURL: {
        ios: "1317604147",
        android: "market://details?id=whiskywall.oshers.com"
      },
      customLocale: {
        title: "Would you mind rating %@?",
        message:
          "It won’t take more than a minute and helps to promote our app. Thanks for your support!",
        cancelButtonLabel: "No, Thanks",
        laterButtonLabel: "Remind Me Later",
        rateButtonLabel: "Rate It Now",
        yesButtonLabel: "Yes!",
        noButtonLabel: "Not really",
        appRatePromptTitle: "Do you like using %@",
        feedbackPromptTitle: "Mind giving us some feedback?"
      },
      callbacks: {
        handleNegativeFeedback: function() {
          console.log("negative feedback");
          window.open("mailto:developer@oshers.com", "_system");
        },
        onRateDialogShow: function(callback) {
          console.log("onRateDialogShow");
          callback(1); // cause immediate click on 'Rate Now' button
        },
        onButtonClicked: function(buttonIndex) {
          console.log("omButtonClicked-rate dialog");
          console.log("onButtonClicked -> " + buttonIndex);
        }
      }
    };
    console.log("Calling promptForRating");
    this.appRate.promptForRating(true);
  }

  getUsername() {
    if (
      this.user != null &&
      this.user.getUser() != null &&
      this.isAuthenticated
    ) {
      return this.user.getUser().getUsername();
    } else {
      return "";
    }
  }

  debugData: string= null;

  ionViewWillEnter() {
    console.log("ionViewWillEnter");
    this.resetCounts();
    console.log("counts " + this.whiskies + " " + this.distilleries);
    this.checkAuth();
    this.sequence = new Date(WhiskyDB.sequence).toUTCString();

    /*
    let dbgMessage = "";

    var numImages = 0;

    let imgTotal = 0;
    let total = 0;

    try {
      console.log("start foreach");
      this.storage.forEach( (value, key, n) =>
      {
        console.log(key);
        if(key.startsWith("image") && key !== "image_sizes" && key !== "image_timestamps") {
          if(value != null) {
            numImages ++;       
          }
        } else {
          console.log(key + ": " + value.length);
          dbgMessage += key + ": " + value.length + "\n";
        }
        this.debugData = dbgMessage + "image count: " + numImages;
        
      });

    }
    catch(err)
    {
      console.log(err);
    } */

  }
  zerolist = "";

  login() {
    let modal = this.modalCtrl.create(this.loginPage, { contactsPage: this });
    modal.present();
    this.checkAuth();
  }

  loginTest()
  {
    this.user
    .login("tester", "Testing-123")
    .then(result => {
      //WhiskyDB.db.setUser(this.user);
        this.checkAuth();
        console.log("Sending login:done for test user");
        this.events.publish("login:done", null);  
        this.loadFromCloud();
      });
      
  }


  logout() {
    this.user.logout();
    this.checkAuth();
  }

  saveToCloud() {
    this.sync.saveToCloud(this);
  }

  loadFromCloud() {
    this.sync.loadFromCloud(this);
  }

  saving = null;
  saving_image = "";
  loading_image = "";

  loadImagesFromCloud() {
    this.saving = "yes";
    this.saving_image = "";
    this.loading_image = "Checking for new images";

    this.imgSync.loadAllImagesFromCloud();
  }

  saveImagesToCloud() {
    //    let loading = this.loadingCtrl.create({ content: "Saving" });
    //    loading.present();
    this.saving_image = "";
    this.loading_image = "";

    this.imgSync.saveImagesToCloud();
  }
  
  eraseDb(ev: any) {
    let alert = this.alertCtrl.create({
      title: "Delete database?",
      message: "Confirm database delete!  This cannot be undone.",
      cssClass: "removeAlert",
      buttons: [
        {
          text: "Cancel",
          role: "Cancel",
          handler: () => {
            console.log("Cancel delete db");
          }
        },
        {
          text: "Delete",
          cssClass: "remove-button",
          handler: () => {
            console.log("Delete database confirmed");
            this.storage.clear();
            WhiskyDB.whisky = [];
            WhiskyDB.distilleries = [];
            WhiskyDB.regions = [];
            WhiskyDB.ratings = [];
            WhiskyDB.emptyShelves();
//            WhiskyDB.shelves = [];
            WhiskyDB.bottlers = [];
            WhiskyDB.basket = [];

            WhiskyDB.db.loadAll();
            this.events.publish("bottlers:updated");
            this.events.publish("shelves:updated");
            this.events.publish("ratings:updated");
            this.events.publish("distilleries:updated");
            this.events.publish("whiskies:updated");

            WhiskyDB.sequence = 0;

            this.resetCounts();

            let toast = this.toastCtrl.create({
              message: "Delete database confirmed",
              duration: 3000
            });
            toast.present();

            this.ionViewWillEnter();
          }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.ts